import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const table = { ...Tables.Table };

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.category'),
      minWidth: 100,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
